export default __webpack_public_path__ + "51df11fab37860995cb00e8c999cd42c.svg";